module.exports = __webpack_public_path__ + "static/media/morning.d3e770e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/morning.png
// module id = 353
// module chunks = 0